import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PageQueryService } from 'src/app/services/page-query.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, OnDestroy {

    constructor(
        private auth: AuthService,
        public pageQuery: PageQueryService,
        public loading: LoadingService,
        private http: HttpService,
        private toastr: ToastrService,
        private modalService: NgbModal
    ) { }
    @ViewChild('filterModal') filterModal: any;
    @ViewChild('deleteModal') deleteModal: any;
    private apiPath = 'reports';
    data: any = {};
    util = UtilitiesService;
    checkedData: any[] = [];

    filterDialog: any = {
        hasFiler: false,
        modal: null,
        model: {
            from_date: null,
            from_time: null,
            to_date: null,
            to_time: null,
            quiz_type: ''
        },
        show: () => {
            this.filterDialog.modal = this.modalService.open(this.filterModal, { keyboard: false, backdrop: 'static', centered: true, size: 'lg' });
        },
        submit: () => {
            this.filterDialog.hasFilter = false;
            let filterField: any = {};
            if (this.filterDialog.model.from_date && this.filterDialog.model.to_date) {
                filterField.from_date = (this.filterDialog.model.from_date + ' ' + (this.filterDialog.model.from_time || '00:00')).trim();
                filterField.to_date = (this.filterDialog.model.to_date + ' ' + (this.filterDialog.model.to_time || '23:59')).trim();
                this.filterDialog.hasFilter = true;
            }
            if (this.filterDialog.model.quiz_type) {
                filterField.quiz_type = this.filterDialog.model.quiz_type;
                this.filterDialog.hasFilter = true;
            }
            if (!this.filterDialog.hasFilter) {
                this.filterDialog.hide();
                return;
            }
            this.filterDialog.modal.close();
            filterField.page = 1;
            this.pageQuery.changeRoute(filterField)
        },
        hide: () => {
            this.filterDialog.model = {
                last_login_at: {},
                created_at: {},
            };
            this.filterDialog.hasFilter = false;
            this.pageQuery.changeRoute({ from_date: '', to_date: '', quiz_type: '', page: 1 });
            this.filterDialog.modal?.close();
        }
    }

    deleteDialog: any = {
        ids: [],
        isDeleting: false,
        modal: null,
        show: (ids: Array<any>) => {
            this.deleteDialog.ids = ids;
            this.deleteDialog.modal = this.modalService.open(this.deleteModal, { keyboard: false, backdrop: 'static', centered: true });
        },
        submit: () => {
            this.deleteDialog.isDeleting = true;
            let urlParameters = Object.entries(this.pageQuery.query.getValue()).filter(k => { return k[1] != null }).map(e => e.join('=')).join('&');
            this.http.Delete(this.apiPath + '/delete?' + urlParameters, (this.deleteDialog.ids?.length ? this.deleteDialog.ids : ['ALL'])).then((r: any) => {
                this.deleteDialog.isDeleting = false;
                if (r.success) {
                    this.checkedData = [];
                    this.data = r?.response?.result || {};
                    this.deleteDialog.modal.close();
                    this.toastr.success('Data successfully deleted', 'Success');
                }
            });
        }
    };

    getData(): void {
        const query: any = this.pageQuery.query.getValue() || {};
        query.limit = query?.limit || 10;
        query.page = query?.page || 1;
        query.from_date = query?.from_date || null;
        query.to_date = query?.to_date || null;
        query.filter = query.filter || '';
        this.http.Get(this.apiPath, query).then((r: any) => {
            if (r.success) {
                this.data = r?.response?.result || {};
            }
        });
    }

    downloadData(): void {
        const pageQuery: any = this.pageQuery.query.getValue() || {};
        let _query: any = {};
        Object.keys(pageQuery).forEach((key) => {
            if (pageQuery[key]) {
                _query[key] = pageQuery[key];
            }
        });
        const query = new URLSearchParams(_query).toString();
        const url = environment.apiUrl + '/' + this.apiPath + '/download?' + query + '&token=' + this.auth.tokenData?.access_token;
        window.open(url, '_blank');
    }

    ngOnInit(): void {
        if (this.pageQuery.queryPage.from_date && this.pageQuery.queryPage.to_date) {
            const from = (this.pageQuery.queryPage.from_date).split(' ');
            const to = (this.pageQuery.queryPage.to_date).split(' ');
            this.filterDialog.hasFilter = true;
            this.filterDialog.model.from_date = from[0];
            this.filterDialog.model.from_time = from[1];
            this.filterDialog.model.to_date = to[0];
            this.filterDialog.model.to_time = to[1];
        }
        if (this.pageQuery.queryPage.quiz_type) {
            this.filterDialog.hasFilter = true;
            this.filterDialog.model.quiz_type = this.pageQuery.queryPage.quiz_type;
        }
        this.loading.start();
        this.pageQuery.init(() => {
            this.getData();
        });
    }

    onSort(ev: any): void {
        const sort = ev.direction == 'desc' ? '-' + ev.column : ev.column;
        this.pageQuery.changeRoute({ order: sort });
    }

    ngOnDestroy(): void {
        this.pageQuery.destroy();
    }

    checkAllCheckBox(ev: any) {
        this.checkedData = [];
        if (ev.target.checked) {
            (this.data?.data || []).forEach((x: any) => {
                this.checkedData.push(x.id);
            });
        }
    }


    isAllCheckBoxChecked(): boolean {
        return (this.data?.data || []).length == this.checkedData.length;
    }

    isCheckBoxChecked(item: any): boolean {
        return this.checkedData.findIndex((e: any) => e == item.id) > -1;
    }

    checkCheckBox(item: any): void {
        const x = this.checkedData.findIndex((e: any) => e == item.id);
        if (x > -1) {
            this.checkedData.splice(x, 1);
        } else {
            this.checkedData.push(item.id);
        }
    }
}
